/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/components/brands-we-love.js":
/*!*********************************************!*\
  !*** ./src/js/components/brands-we-love.js ***!
  \*********************************************/
/***/ (() => {

document.addEventListener("DOMContentLoaded", function () {
  var tabs = document.querySelectorAll(".tabs-lists li");
  var tabContents = document.querySelectorAll(".brands-tabs-content");

  // Set the first tab and its content as active by default
  tabs[0].classList.add("active");
  tabContents[0].classList.add("active");

  // Add click event listeners to each tab
  tabs.forEach(function (tab, index) {
    tab.addEventListener("mouseenter", function () {
      // Remove 'active' class from all tabs and content
      tabs.forEach(function (t) {
        return t.classList.remove("active");
      });
      tabContents.forEach(function (content) {
        return content.classList.remove("active");
      });

      // Add 'active' class to the clicked tab and the corresponding content
      tab.classList.add("active");
      tabContents[index].classList.add("active");
    });
  });

  /*
    Play & Pause
    ----------------------------------
  */
  var brandsPlayPause = document.querySelectorAll('.brands-play-pause');
  brandsPlayPause.forEach(function (button) {
    button.addEventListener('click', function () {
      var videoId = this.getAttribute('data-video-id');
      var video = document.getElementById(videoId);
      if (video.paused) {
        video.play();
        this.classList.add("hide-play");
        this.classList.remove('hide-pause');
      } else {
        video.pause();
        this.classList.remove("hide-play");
        this.classList.add("hide-pause");
      }
    });
  });

  // Initial check for autoplay on page load
  tabs.forEach(function (tab, index) {
    var video = document.getElementById("brands-video-".concat(index + 1));
    var onLoadPlayPause = document.querySelector(".brands-play-pause[data-video-id=\"brands-video-".concat(index + 1, "\"]"));
    if (video) {
      if (video.autoplay) {
        onLoadPlayPause.classList.add("hide-play");
        onLoadPlayPause.classList.remove("hide-pause");
      } else {
        onLoadPlayPause.classList.add("hide-pause");
        onLoadPlayPause.classList.remove("hide-play");
      }
    }
  });

  /*
    Progress Bar | Scroll on Mobile
    ----------------------------------
  */
  var scrollableBrands = document.getElementById('scrollableBrands');
  var progressBarBrands = document.getElementById('progressBarBrands');
  var minProgress = 20; // Since initially items are being displayed minimum progress set to 20%

  // Function to update the progress bar width based on the scroll position
  function brandsProgressBar() {
    var scrollWidth = scrollableBrands.scrollWidth - scrollableBrands.clientWidth;
    var scrollLeft = scrollableBrands.scrollLeft;
    var scrollPercent = scrollLeft / scrollWidth * 100;

    // Ensure the progress is at least 15% on page load
    if (scrollPercent < minProgress) {
      scrollPercent = minProgress;
    }
    progressBarBrands.style.width = scrollPercent + "%";
  }

  // Event listener for horizontal scroll
  scrollableBrands.addEventListener('scroll', brandsProgressBar);

  // Initialize the progress bar on page load
  brandsProgressBar();
});

/***/ }),

/***/ "./src/sass/theme-custom.scss":
/*!************************************!*\
  !*** ./src/sass/theme-custom.scss ***!
  \************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/sass/sections/brands-we-love.scss":
/*!***********************************************!*\
  !*** ./src/sass/sections/brands-we-love.scss ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/assets/brands-we-love": 0,
/******/ 			"assets/brands-we-love": 0,
/******/ 			"assets/theme-custom": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkthe_walking_co"] = self["webpackChunkthe_walking_co"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["assets/brands-we-love","assets/theme-custom"], () => (__webpack_require__("./src/js/components/brands-we-love.js")))
/******/ 	__webpack_require__.O(undefined, ["assets/brands-we-love","assets/theme-custom"], () => (__webpack_require__("./src/sass/theme-custom.scss")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/brands-we-love","assets/theme-custom"], () => (__webpack_require__("./src/sass/sections/brands-we-love.scss")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;